import { getAPIPath, request } from './core'

export const fetchBenchmarkingPlusValues = (businessId: string) =>
  request(
    getAPIPath('analytics/benchmarking'),
    { method: 'GET', params: { businessId } },
    true,
  )
